export const SET_MODAL_DATA = "SET_MODAL_DATA";
export const HIDE_DOMAIN_ACCESS_MODAL = "HIDE_DOMAIN_ACCESS_MODAL";
export const CHANGE_ACCESS_LIMITED_MODAL_VISIBILITY_STATUS = "CHANGE_ACCESS_LIMITED_MODAL_VISIBILITY_STATUS";

export interface DomainAccessModalDataState {
  isDomainAccessModalOpen: boolean;
  accessName: string | string[];
  showAccessLimitedModal: boolean;
}

interface DomainAccessModalSetModalDataAction {
  type: typeof SET_MODAL_DATA;
  meta: {
    params: {
      isDomainAccessModalOpen: boolean;
      accessName: string | string[];
    };
  };
}

interface HideDomainAccessModalAction {
  type: typeof HIDE_DOMAIN_ACCESS_MODAL;
}

interface ChangeAccessLimitedModalVisibilityStatus {
  type: typeof CHANGE_ACCESS_LIMITED_MODAL_VISIBILITY_STATUS;
  meta: {
    params: {
      showAccessLimitedModal: boolean;
    };
  };
}

export type DomainAccessModalActionTypes =
  | DomainAccessModalSetModalDataAction
  | HideDomainAccessModalAction
  | ChangeAccessLimitedModalVisibilityStatus;
